import { cn } from '@discover-lib/utils';
import SortSelect from '@discover-components/restaurant/filters/sortSelect';
import Label from '@discover-ui/label';

export type RestaurantListSummaryProps = {
  className?: string;
};

export default function RestaurantListSummary({ className }: RestaurantListSummaryProps) {
  return (
    <div className={cn('hidden flex-row items-center gap-2 lg:flex lg:min-h-12', className)}>
      <Label className="ml-auto hidden text-sm lg:flex" htmlFor="sort-select">
        Sort By
      </Label>
      <SortSelect
        triggerProps={{ kind: 'outline', scale: 'md' }}
        className="hidden min-w-36 max-w-none font-medium lg:flex"
      />
    </div>
  );
}
